"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get getUniqueColumnAliasName () {
        return getUniqueColumnAliasName;
    },
    get getUniqueColumnName () {
        return getUniqueColumnName;
    }
});
function getUniqueColumnName(columns, initialName = 'field') {
    let c = 0;
    while(columns.some((col)=>col.column_name === `${initialName}${c || ''}`)){
        c++;
    }
    return `${initialName}${c || ''}`;
}
function getUniqueColumnAliasName(columns, initialName = 'field') {
    let c = 0;
    while(columns.some((col)=>col.title === `${initialName}${c || ''}`)){
        c++;
    }
    return `${initialName}${c || ''}`;
}
